<template>
  <div class="header-user-menu">
    <icon-dots-horizontal
      width="30"
      height="30"
      class="dots"
      ref="tray"
      icon-color="#fff"
    />

    <div class="dropdown-menu" ref="dropdown">
      <div
        v-if="!currentUser.hasPremiumLicense"
        class="dropdown-menu-item"
        @click="onBuyPremiumLicenseClick"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("header.tray.buyNetNanny") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div
        v-if="currentUser.hasPaidLicense"
        class="dropdown-menu-item"
        @click="onAddChildProfileClick"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("header.tray.addChildProfile") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div
        v-if="currentUser.hasPaidLicense"
        class="dropdown-menu-item"
        @click="openInstalledDevices"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("manageInstalls") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div
        v-if="currentUser.hasPaidLicense"
        class="dropdown-menu-item"
        @click="openNamedLocations"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("header.tray.manageLocations") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div
        v-if="currentUser.hasPaidLicense"
        class="dropdown-menu-item"
        @click="openManageRequests"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("manageRequests") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div
        class="dropdown-menu-item"
        @click="openChangePassword"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("changePassword") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <a
        class="dropdown-menu-item"
        :href="addExtrasToUrl('https://www.netnanny.com/support/net-nanny-10/')"
        target="_blank"
        @click="openHelpPage"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("header.tray.help") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </a>

      <div
        class="dropdown-menu-item"
        @click="onLogout"
      >
        <div class="dropdown-menu-item-label">
          {{ $t("header.tray.logout") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <icon-logout width="24" height="24" />
        </div>
      </div>

      <div
        v-if="$mq !== 'mobile'"
        class="dropdown-menu-item app-info"
      >
        {{ $t("header.tray.build", { appVersion, appBuild }) }}
      </div>
    </div>
  </div>
</template>

<script>
  import tippy from 'tippy.js'
  import analytics from '@/services/analytics.js'

  import { logout } from '@/services/auth.js'

  export default {
    mounted() {
      this.initUserMenuDropdown()
    },

    methods: {

      addExtrasToUrl(p_url) {
        return p_url + this.$i18n.locale + "/?utm_source=parentApp&utm_medium=web";
      },
      
      initUserMenuDropdown() {
        tippy(this.$refs.tray.$el,  {
          allowHTML: true,
          content: this.$refs.dropdown,
          hideOnClick: true,
          interactive: true,
          trigger: 'click',
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: true,
          inertia: true,
          duration: [400, 300]
        })
      },

      onBuyPremiumLicenseClick() {
        analytics.sendEvent('Pk_BuyNN')
      },

      onAddChildProfileClick() {
        analytics.sendEvent('Pk_AddChild_Ellip')
      },

      openInstalledDevices() {
        analytics.sendEvent('Pk_ManageInstalls_Ellip')

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'devices'
          })

          tippy.hideAll()

          return
        }

        this.showModal('devices')
        tippy.hideAll()
      },

      openNamedLocations() {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'locations'
          })

          tippy.hideAll()

          return
        }

        this.showModal('geofence')
        tippy.hideAll()
      },

      openManageRequests() {
        this.$router.push({
          name: 'manageRequests'
        })

        tippy.hideAll()
      },

      openChangePassword() {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'password'
          })

          tippy.hideAll()

          return
        }

        this.showModal('password')
        tippy.hideAll()
      },

      onLogout() {
        logout()
        tippy.hideAll()
        this.$router.push({ name: 'home' })
      },

      openHelpPage() {
        analytics.sendEvent('Pk_Help_Ellip')
      }
    },

    computed: {
      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      ...mapGetters('app', {
        appVersion: 'getVersion',
        appBuild: 'getBuild'
      }),
    }
  }
</script>

<style lang="scss" scoped>
  .dots {
    cursor: pointer;
  }

  .app-info {
    font-size: 14px;
    font-weight: 300;
    color: map-get($colors, disabled);
    cursor: auto;
  }
</style>
